import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import { NETWORK_THREAT_PATH } from "@js2/path";
import { getRoute } from "@modules/network/components/common/NetworkLink";
import { useNetworkRoute } from "@modules/network/hooks/useNetworkRoute";

const DetectionsNavItem = () => {
  const [name = "", value = ""] = useNetworkRoute();
  const route = getRoute(NETWORK_THREAT_PATH.DETECTIONS, name, value);
  return (
    <Nav.Item>
      <Nav.Link
        as={Link}
        to={route}
        key="detections"
        eventKey="detections"
        data-testid="detections-nav-item"
      >
        Detections
      </Nav.Link>
    </Nav.Item>
  );
};

export default DetectionsNavItem;
